import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'STESAJ';

  

  mostrarBoton: boolean = true;
  rutaActual: string = '';
  cargando: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.cargando = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        const ruta = (event as NavigationEnd).urlAfterRedirects ?? (event as any).url;
        this.mostrarBoton = !(ruta === '/login' || ruta === '/register' || ruta === '/landing');
        setTimeout(() => (this.cargando = false), 300);
      }
    });
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
  
    const estaEnFinal = scrollTop + windowHeight >= documentHeight - 10;

    this.mostrarBoton =  !estaEnFinal;
  }
  
  irAlFinal(): void {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }
  
}
